export default "__VITE_ASSET__C2XPh4$M__"